import Icon from '../components/Icon.vue'

Icon.register({"chess-king":{"width":448,"height":512,"paths":[{"d":"M416 476V500C416 506.6 410.6 512 404 512H44C37.4 512 32 506.6 32 500V476C32 469.4 37.4 464 44 464H404C410.6 464 416 469.4 416 476zM408 152H248V104H298A6-6 0 0 1 304 98V62A6-6 0 0 1 298 56H248V6A6-6 0 0 1 242 0H206A6-6 0 0 1 200 6V56H150A6-6 0 0 1 144 62V98A6-6 0 0 1 150 104H200V152H40C12.5 152-6.8 179.2 2.3 205.3L87.6 448H360.4L445.7 205.3C454.8 179.2 435.5 152 408 152z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chess-king.js
// module id = iGR0
// module chunks = 0